import { Modal, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { modal } from "@/utils/constant";

function CancelModal({ hide, show, session, organization_sheet, socket }) {
  const navigate = useNavigate();

  const handleCancelSession = async (e) => {
    const session_remove_data = {
      id: Number(session?.id),
      cancel_session: new Date(),
      total_sheet: session.organization_sheet + organization_sheet,
      organization_id: session.organization_id,
    };
    
    socket.emit('update-session-data', session_remove_data);
    socket.on('update-session-data', (response) => {
      if (response.status === true) {
        navigate("/session");
      }
      socket.off('update-session-data');
    });
  };

  return (
    <>
      <Modal show={show} onHide={hide} size="lg" centered>
        <Modal.Header className="bg-secondary" closeButton>
          <Modal.Title>{modal?.cancelSessionModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-10 px-lg-14">
          <p>
            {modal?.cancleSessionModalText}{" "}
            <span className="font-bold">
              {modal?.cancleSessionModalBodyText}
            </span>{" "}
            {modal?.cancleSessionModalQuestion}
          </p>
          <Row className="mt-8">
            <Col>
              <Button
                variant="secondary"
                className="font-semibold w-full"
                onClick={() => handleCancelSession()}
              >
                {modal?.cancelSessionModal}
              </Button>
            </Col>
            <Col>
              <Button
                variant="outline-primary"
                className="font-semibold w-full"
                onClick={hide}
              >
                {modal?.cancleSessionNevermind}
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default CancelModal;
